import { Checkbox } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useApi } from "../api"
import { ErrorDialog } from "../components/ErrorDialog";
import { ErrorResponseDialog } from "../components/ErrorResponseDialog";
import { ICargo } from "../interfaces";
import { Utils } from "../utils";

export const LoginPage = () => {
  const { projectCode } = useParams()
  const api = useApi(projectCode);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [agreeTos, setAgreeTos] = useState<boolean>(false);

  useEffect(() => {
    if (Utils().isLogin()) {
      api.logout(() => {
        window.localStorage.removeItem('memberId');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('team');
        window.localStorage.removeItem('sessionId');
        window.localStorage.removeItem('expire');
      });
    }

    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    const state = url.searchParams.get("state");
    if (!projectCode || !code || !state) return;

    if (url.searchParams.has("code")) {
      api.lineLogin(projectCode, code, window.location.href.split('?')[0], (cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          window.location.href = '/web/home';
        } else {
          window.location.href = `/web/login/${projectCode}`;
        }
      })
    }
  }, [api, projectCode])

  return (
    <>
      <div className="py-5" style={{ backgroundColor: '#e6e6e6' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <div className="row bg-white radius-12 mx-0" style={{ boxShadow: '0px 0px 10px 5px #d7d7d7' }}>
            <div className="col-md-6 text-center px-4">
              <div className="py-3 fw-bolder txt-26 mt-4">登入</div>
              <div className="w-100 border-down mb-4"></div>

              <div className="mb-4 fw-normal text-sm text-start mx-0 mx-sm-4">登入您的帳號</div>
              {/* <div className="loginT">Email</div> */}
              <div className="d-flex flex-column">
                <input type="text" className="border-1 py-2 px-3 mx-0 mx-sm-4 border-slate-400" id="username" value={username} onChange={(e) => {
                  setUsername(e.target.value.trim());
                }} placeholder="輸入Email" />
                <div className="p-1"></div>
                {/* <div className="loginT">密碼</div> */}
                <input type="password" className="border-1 py-2 px-3 mx-0 mx-sm-4 border-slate-400 mt-3" id="password" value={password} onChange={(e) => {
                  setPassword(e.target.value.trim());
                }} placeholder="輸入密碼" />
              </div>
              <div id="login-btn" className="bt-buy my-4 py-2 mx-auto" style={{ borderRadius: '1.875rem', width: '68px' }} onClick={() => {
                if (!agreeTos) {
                  ErrorDialog({ title: "未同意使用者條款", content: "請先同意使用者條款" })
                  return
                }
                api.login(username, password, (cargo: ICargo) => {
                  if (cargo.returnCode === '000000') {
                    const url = new URL(window.location.href);
                    if (url.searchParams.has('redirect_url')) {
                      navigate(url.searchParams.get('redirect_url') || '/web/home')
                    } else {
                      navigate('/web/home')
                    }
                  } else {
                    ErrorResponseDialog(cargo, t)
                  }
                })
              }}>登入</div>

            </div>

            <div className="col-md-6 d-flex flex-column justify-center text-center cursor-pointer px-4">
              <div className="text-center my-3">或透過以下方式登入</div>

              <div id="line-login-btn" className="mx-auto" onClick={() => {
                if (!agreeTos) {
                  ErrorDialog({ title: "未同意使用者條款", content: "請先同意使用者條款" })
                  return
                }
                const url = new URL('https://access.line.me/oauth2/v2.1/authorize');
                url.searchParams.set('response_type', 'code');
                url.searchParams.set('client_id', '1657469590');
                url.searchParams.set('redirect_uri', window.location.href);
                url.searchParams.set('state', Utils().uuid());
                url.searchParams.set('scope', 'profile openid email');

                window.location.href = url.toString();
              }}>
                <div className="signLine d-flex w-fit">
                <div className="line">
                  <img src={require('../assets/img/linew.png')} alt="" />
                </div>
                <div className="pl-2 pr-3" style={{ width: 'auto' }}>使用 LINE 登入</div>
                </div>
              </div>
            </div>

            <div className="col-md-6 text-center px-4">
              <div className="d-flex justify-content-between c576 txt-14 mt-3">
                <div><a href="forget.html">忘記密碼?</a></div>
                <div><a href="/web/signup/nft">注冊</a></div>
              </div>

              <div className="w-100 my-3"></div>



            </div>
            <div className="col-md-6 text-center px-4">

            </div>

          </div>
          <div className="">
          <div className="text-center mt-3">
                <Checkbox colorScheme={"purple"} isChecked={agreeTos} onChange={(e) => {
                  setAgreeTos(e.target.checked)
                }}>
                  <div className="text-purple-700">同意使用者條款《隱私權政策》</div>
                </Checkbox>
              </div>
              
                <div className="text-center mt-2 mb-5">
                  <a href="/pdf/protocol.pdf" target={'_blank'}><span className="text-purple-700">使用者條款《隱私權政策》</span></a></div>
                </div>
        </div>
      </div>
    </>
  )
}
